import { DialogObject } from '../../../../components/dialog/dialog.types';
import { PaaRepository } from '../../../../store/paa-state/paa-state.repository';

interface getPaaDeleteObjectProps {
  store: PaaRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPaaDeleteObject = ({ representation, action, toggleVisiblity, store }: getPaaDeleteObjectProps): DialogObject => {
  return {
    title: `Suppression de Plan annuel des achats (${representation})`,
    description: 'Vous allez supprimer le plan annuel des achats, cette action est irréversible.',
    onHide() {
      store.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => toggleVisiblity?.(),
        variant: 'secondary',
      },
    ],
  };
};
